import React from 'react';
import {testata} from '../moduli/leggi';

/** Chiede alle testate di rileggere il saldo (lo stesso avviso di cassa e schedina). */
export function avvisaSaldo() {
  window.dispatchEvent(new Event('balanceUpdated'));
}

const PAUSA_MESSAGGI = 2000;

/**
 * IL SALDO MENTRE SI GIOCA: con un gioco del casino' aperto la testata
 * rilegge il saldo da sola, senza ricaricare la pagina.
 *
 * Il gioco gira nella cornice e scala o paga sul conto vero, ma la pagina non
 * lo sa: nessuno manda «balanceUpdated». Qui lo si manda noi:
 *   - ogni `ogni` secondi (modulo Testata › Rilegge il saldo ogni), solo con
 *     la pagina in primo piano: in secondo piano non c'e' nessuno che guarda;
 *   - appena la pagina torna in primo piano;
 *   - quando il gioco scrive alla pagina (molti fornitori avvisano a ogni
 *     giro con postMessage): al piu' una volta ogni due secondi, e un
 *     messaggio arrivato nella pausa rilegge appena finisce, cosi' l'ultima
 *     giocata non si perde;
 *   - uscendo dal gioco, per l'ultima cifra.
 * Il saldo lo rileggono le testate che lo mostrano (GuscioNova, BarraAlta),
 * che ascoltano gia' «balanceUpdated»: una sola chiamata, la stessa di sempre.
 *
 * `cornice` e' il riquadro che contiene la finestra del gioco (l'iframe).
 * `attivo` falso (prova gratuita, ospite, gioco non ancora partito) o
 * l'interruttore spento dal backoffice: non fa niente.
 */
export function useSaldoInGioco(attivo, cornice) {
  const ogni = testata().saldoOgni;
  React.useEffect(() => {
    if (!attivo || !ogni) return undefined;
    const inVista = () => !document.hidden;

    const giro = window.setInterval(() => { if (inVista()) avvisaSaldo(); }, ogni * 1000);
    const allaVista = () => { if (inVista()) avvisaSaldo(); };
    document.addEventListener('visibilitychange', allaVista);

    let ultimo = 0;
    let coda = null;
    const dalGioco = (e) => {
      const iframe = cornice && cornice.current && cornice.current.querySelector('iframe');
      const finestra = iframe && iframe.contentWindow;
      if (!finestra || e.source !== finestra) return;
      const ora = Date.now();
      if (ora - ultimo >= PAUSA_MESSAGGI) {
        ultimo = ora;
        avvisaSaldo();
      } else if (!coda) {
        /* Arrivato durante la pausa: si rilegge appena finisce. */
        coda = window.setTimeout(() => { coda = null; ultimo = Date.now(); avvisaSaldo(); }, ultimo + PAUSA_MESSAGGI - ora);
      }
    };
    window.addEventListener('message', dalGioco);

    return () => {
      window.clearInterval(giro);
      window.clearTimeout(coda);
      document.removeEventListener('visibilitychange', allaVista);
      window.removeEventListener('message', dalGioco);
      avvisaSaldo();
    };
  }, [attivo, ogni, cornice]);
}
